const issueMessages = {
  'issueInfo.issue.header': '認証用QRコード発行画面',
  'issueInfo.issue.footer':
    'このQRコードの有効期限は「{expireDateString}」です。',
  'issueInfo.issue.updateExpire': 'QRコードの有効期限を更新できます',
  'issueInfo.issue.updatableDate':
    '(有効期限は「{updatableDate}」まで更新可能です)',
  'issueInfo.issue.errorMessage': 'QRコードが発行されていません',
  'issueInfo.issue.createButton': 'QRコード発行',
  'issue.QRCode.update.button.title': '更新',
  'issue.QRCode.delete.button.title': 'QRコード削除',
  'issue.QRCode.delete.userPrompt.button.title': '削除しますか？',
  'issue.QRCode.delete.userPrompt.button.ok': 'はい',
  'issue.QRCode.delete.userPrompt.button.no': 'いいえ',
};

export default issueMessages;
